import { formatCalendarDate } from '../../../Utils/calendarDate';
import { getDeliveryClosedReason } from '../../../Utils/storeStatus';
import { IonButton, IonButtons, IonChip, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonLoading, IonModal, IonRow, IonTitle, IonToast, IonToolbar, useIonAlert } from '@ionic/react';
import { addCircle, arrowBackOutline, calendarOutline, locationOutline, removeCircle, syncOutline, ticketOutline, trash } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { MessageContext } from '../../../contexts/MessageContext';
import useAnalytics from '../../../hooks/useAnalytics';
import { cadastrarELogarDireto, cashbackCarregar, requestService } from '../../../Utils/Services';
import { saveDeliveryAddress, saveDeliveryTerms } from '../../../Utils/deliveryAddressStorage';
import PedidoFechar from '../../Cliente/Home/pages/OrdensFechar/OrdensFechar';
import Agendamento from '../Agendamento/Agendamento';
import Cashback from '../Cashback/Cashback';
import Cupom from '../Cupom/Cupom';
import Endereco from '../Endereco/Endereco';
import Entrar from '../Entrar/Entrar';
import './Carrinho.css';
import CartSuggestions from './CartSuggestions';
import { cartMoney, cartNumber } from '../../../Utils/cartItem';
import { evaluateCartCoupon } from '../../../Utils/cartCoupon';
import { appliedCashback } from '../../../Utils/cartCashback';
import { useDeliveryQuote } from '../../../hooks/useDeliveryQuote';
import { readPendingCheckout } from '../../../Utils/pendingCheckout';

type CashbackLookup = { status: 'ready'; available: number } | { status: 'login' | 'error' | 'stale' };

type Props = {
  logado: any;
  closeAction: Function;
  closeActionVoltar: Function;
  adicionarItem?: Function;
  onChooseProduct?: (productId: string) => Promise<void>;
}

const Carrinho: React.FC<Props> = (props: Props) => {



  const history = useHistory<any>();

  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showLoading, setShowLoading] = useState(false);


  // Estados de modais e alertas
  const [mostrarAlerta] = useIonAlert();

  // Estados de dados e listas
  const { listaItemProdutos, setListaItemProdutos } = useContext(MessageContext);
  const [valorTotalProdutos, setValorTotalProdutos] = useState<any>();
  const [valorTotal, setValorTotal] = useState<any>();

  // State: Detalhes do Endereço
  const [showPedidoFechar, setShowPedidoFechar] = useState(false);
  const [showDetalhesEndereco, setShowDetalhesEndereco] = useState(false);
  const [showModalDesconto, setShowModalDesconto] = useState(false);
  const inputRefEndereco = useRef<any>(null);
  const [endereco, setEndereco] = useState("");
  const [enderecoLat, setEnderecoLat] = useState("");
  const [enderecoLng, setEnderecoLng] = useState("");
  const [complemento, setComplemento] = useState("");
  const [bairro, setBairro] = useState(localStorage.getItem('bairroEntrega') || '');
  const [taxaEntrega, setTaxaEntrega] = useState<any>();
  const [tempoEntrega, setTempoEntrega] = useState<any>();
  const [desconto, setDesconto] = useState<any>();
  const [cupom, setCupom] = useState<any>();
  const [taxaServico, setTaxaServico] = useState<any>();

  const [showModalAgendamento, setShowModalAgendamento] = useState(false);
  const [tipoAgendamento, setTipoAgendamento] = useState("");
  const [dataAgendamento, setDataAgendamento] = useState("");
  const [horaAgendamento, setHoraAgendamento] = useState("");

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);
  const deliveryQuote = useDeliveryQuote(dadosEmpresa?.pk, { endereco, latitude: enderecoLat, longitude: enderecoLng, bairro,
    agendamento: tipoAgendamento === 'AGENDADO' ? { data: dataAgendamento, hora: horaAgendamento } : undefined },
    (taxa, tempo) => { setTaxaEntrega(taxa); setTempoEntrega(tempo); });
  const analytics = useAnalytics();

  // Analytics: AbandonCheckout — dispara 5min após inatividade com itens no carrinho
  useEffect(() => {
    if (!listaItemProdutos || listaItemProdutos.length === 0) return;
    const timer = setTimeout(() => {
      try {
        const totalNum = parseFloat(String(valorTotalProdutos || 0).replace(/\./g, '').replace(/\,/g, '.')) || 0;
        analytics.trackAbandonCheckout(listaItemProdutos, totalNum);
      } catch (e) { /* noop */ }
    }, 5 * 60 * 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listaItemProdutos]);
  const [showModalCashBack, setShowModalCashBack] = useState(false);
  const [totalCashBack, setTotalCashBack] = useState(0);
  const [listCashBack, setListCashBack] = useState<any[]>([]);
  const [resgateCashBack, setResgateCashBack] = useState(0);
  const [showModalEntrar, setShowModalEntrar] = useState(false);
  const [cashbackAuthenticated, setCashbackAuthenticated] = useState(false);
  const cashbackActionInFlight = useRef(false);
  const cashbackSequence = useRef(0);
  const cashbackRequest = useRef<{ company: string; session: string; promise: Promise<CashbackLookup> } | null>(null);
  const cashbackCompany = useRef(dadosEmpresa?.pk);
  cashbackCompany.current = dadosEmpresa?.pk;

  const cashbackSession = () => JSON.stringify(['token', 'telefone', 'perfil', 'marca'].map(key => localStorage.getItem(key)));

  function reportCashbackError(message: string) {
    setTextToast(message); setShowToast(true);
  }

  function recoverBeforeChangingCashback() {
    try {
      const company = cashbackCompany.current;
      const contact = localStorage.getItem('telefone') || '';
      if (!company || !contact || !readPendingCheckout(company, contact)) return false;
      setShowModalCashBack(false); setShowModalEntrar(false); setShowPedidoFechar(true);
      reportCashbackError('Há uma compra em andamento. Consulte o pedido ou Pix antes de alterar o cashback.');
    } catch (error) {
      reportCashbackError((error as Error).message);
    }
    return true;
  }

  async function carregarCashback(empresaid: string): Promise<CashbackLookup> {
    const session = cashbackSession();
    const pending = cashbackRequest.current;
    if (pending?.company === empresaid && pending.session === session) return pending.promise;
    const sequence = ++cashbackSequence.current;
    const current = () => sequence === cashbackSequence.current && cashbackCompany.current === empresaid && session === cashbackSession();
    let result: CashbackLookup = { status: 'error' };

    const promise = requestService(cashbackCarregar.url.replace("{id}", empresaid.replace(/#/g, '%23')), {
      method: cashbackCarregar.method,
      headers: [
        ["token", window.localStorage.getItem("token")],
        ["perfil", window.localStorage.getItem("perfil")],
        ["marca", window.localStorage.getItem("marca") || ""],
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        if (!current()) return;
        const amount = Number(response.totalCashback);
        const available = Number.isFinite(amount) ? Math.max(0, amount) : 0;
        setCashbackAuthenticated(true);
        setTotalCashBack(available);
        setListCashBack(response.items || []);
        result = { status: 'ready', available };
      },
      (error: any) => {
        if (!current()) return;
        if (error.status === 401 || (error.status === 400 && !localStorage.getItem('token'))) {
          setCashbackAuthenticated(false);
          setTotalCashBack(0); setListCashBack([]); setResgateCashBack(0);
          result = { status: 'login' };
        }
      }, false).then((): CashbackLookup => current() ? result : { status: 'stale' });
    const request = { company: empresaid, session, promise };
    cashbackRequest.current = request;
    try {
      return await promise;
    } finally {
      // Share only in-flight work. Later actions must read the current balance.
      if (cashbackRequest.current === request) cashbackRequest.current = null;
    }
  }

  async function confirmarUsoCashback(selected?: number) {
    if (cashbackActionInFlight.current || recoverBeforeChangingCashback()) return;
    if (selected === 0) { setResgateCashBack(0); setShowModalCashBack(false); return; }
    const company = cashbackCompany.current;
    if (!company) return;
    cashbackActionInFlight.current = true; setShowLoading(true);
    try {
      const result = await carregarCashback(company);
      if (result.status !== 'stale' && recoverBeforeChangingCashback()) return;
      if (result.status === 'ready') {
        if (selected === undefined) setShowModalCashBack(true);
        else {
          setResgateCashBack(appliedCashback(Math.min(selected, result.available), valorTotalProdutos, taxaEntrega, desconto));
          setShowModalCashBack(false);
        }
      } else if (result.status === 'login') {
        setShowModalCashBack(false); setShowModalEntrar(true);
      } else if (result.status === 'error') {
        reportCashbackError('Não foi possível consultar seu cashback. Tente novamente. Seu carrinho foi mantido.');
      }
    } finally {
      cashbackActionInFlight.current = false; setShowLoading(false);
    }
  }

  useEffect(() => {

    cashbackCompany.current = dadosEmpresa?.pk;
    console.log("entrou carrinho");
    setEndereco(localStorage.getItem("enderecoEntrega") || "");
    setEnderecoLat(localStorage.getItem("latitudeEntrega") || "");
    setEnderecoLng(localStorage.getItem("longitudeEntrega") || "");
    setTaxaEntrega(localStorage.getItem("taxaEntrega") || "");
    setTempoEntrega(localStorage.getItem("tempoEntrega") || "");
    setComplemento(localStorage.getItem("complementoEntrega") || "");

    setTipoAgendamento(localStorage.getItem("tipoAgendamento") || "");
    setDataAgendamento(localStorage.getItem("dataAgendamento") || "");
    setHoraAgendamento(localStorage.getItem("horaAgendamento") || "");

    carregarSomasItemProdutos();

    const empresaid = dadosEmpresa?.pk || "";
    if (dadosEmpresa?.cashbackAtivado && props.logado && empresaid) {
      try {
        if (!readPendingCheckout(empresaid, localStorage.getItem('telefone') || '')) void carregarCashback(empresaid);
      } catch { /* A compra pendente precisa ser conferida no checkout antes de consultar o benefício. */ }
    }
    return () => { ++cashbackSequence.current; cashbackCompany.current = undefined; };
  }, []);

  useEffect(() => {

    try {
      let taxaServicoFloat = parseFloat(taxaServico?.replace(/\./g, '').replace(/\,/g, '.'));
      let descontoFloat = parseFloat(desconto?.replace(/\./g, '').replace(/\,/g, '.'));
      let taxaEntregaFloat = parseFloat(taxaEntrega?.replace(/\./g, '').replace(/\,/g, '.'));

      let valorTotalRecalculado = 0;
      if (valorTotalProdutos) {
        valorTotalRecalculado = parseFloat(valorTotalProdutos.replace(/\./g, '').replace(/\,/g, '.'));
      }

      if (taxaEntrega) {
        valorTotalRecalculado += (taxaEntregaFloat ? taxaEntregaFloat : 0);
      }

      if (desconto) {
        valorTotalRecalculado -= (descontoFloat ? descontoFloat : 0);
      }

      if (resgateCashBack) {
        valorTotalRecalculado -= (resgateCashBack ? resgateCashBack : 0);
      }

      if (taxaServico) {
        valorTotalRecalculado += (valorTotalRecalculado * (taxaServicoFloat / 100));
      }

      setValorTotal(valorTotalRecalculado.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }));

    } catch (error) {
      console.log("erro ao calcular", error);
    }
  }, [taxaEntrega, taxaServico, desconto, resgateCashBack, valorTotalProdutos]);

  useEffect(() => {
    setValorTotalProdutos(cartMoney((listaItemProdutos || []).reduce(
      (sum: number, item: any) => sum + cartNumber(item.subtotal), 0)));
  }, [listaItemProdutos]);

  const updateQuantity = (index: number, delta: number) => {
    setListaItemProdutos((current: any[]) => {
      const quantity = cartNumber(current[index]?.quantidade) + delta;
      if (quantity < 1) return current;
      return current.map((item: any, itemIndex: number) => itemIndex === index
        ? { ...item, quantidade: String(quantity), subtotal: cartMoney(cartNumber(item.valor) * quantity) } : item);
    });
  };

  // Reprecificação e ofertas alteram a base e podem deixar o pedido abaixo do
  // mínimo do cupom, inclusive se o checkout já estiver aberto.
  useEffect(() => {
    if (!cupom) return;
    const result = evaluateCartCoupon(dadosEmpresa?.configuracoesCupom, cupom, valorTotalProdutos, taxaEntrega);
    if (!result.valid) {
      setCupom('');
      setDesconto('');
      setTextToast(`Cupom removido. ${result.message}`);
      setShowToast(true);
      return;
    }
    setDesconto((prev: any) => prev === result.discount ? prev : result.discount);
  }, [cupom, valorTotalProdutos, taxaEntrega, dadosEmpresa?.configuracoesCupom]);

  const loadItemProdutos = () => {

    if (listaItemProdutos == undefined) return;

    if (listaItemProdutos.length === 0) {
      return (
        <>
          <IonItem lines="none">

            <IonLabel>
              <h2 style={{ "verticalAlign": "middle" }}><strong>Nenhum item adicionado</strong></h2>
            </IonLabel>

          </IonItem>
        </>

      );
    }

    return (
      <>
        <IonGrid>

          {listaItemProdutos.map((value: any, index: any) => (
            <>

              <IonRow style={{ borderColor: '#dddddd', borderWidth: '1px', borderBottomStyle: 'dashed' }}>


                <IonCol size="9">



                  {(value.descricao && Array.isArray(value.descricao)) ? (

                    <>
                      {(value.tipo === "pizzas") ? (
                        <div>{value.tamanho} {value.quantidadeSabores} SABORES</div>
                      ) : (
                        <div>{value.categoria}</div>
                      )}
                      {value.descricao.map((item: any, index: number) => (
                        <div key={"desc" + index}>
                          - {item.descricao} (<IonLabel style={{ textAlign: "right", fontSize: "12px" }}>R$ {item.valor?.toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}</IonLabel>)
                        </div>
                      ))}
                    </>

                  ) : (
                    <div key={"desc" + index}>
                      {value.descricao} (<IonLabel style={{ textAlign: "right", fontSize: "12px" }}>R$ {value.valor?.toLocaleString('pt-br', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}</IonLabel>)

                    </div>
                  )}



                </IonCol>


                <IonCol style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }} sizeXs="3" >
                  <IonLabel style={{ textAlign: "right" }}>{value.subtotal}</IonLabel>
                </IonCol>
                <IonCol sizeSm='6'>
                  <IonLabel style={{ textAlign: "right", fontSize: "12px" }} >
                    <IonChip style={{ margin: 0, padding: '5px' }} disabled={false}>
                      <IonIcon size='large' color='danger' icon={removeCircle} onClick={() => updateQuantity(index, -1)}></IonIcon>
                      <IonLabel style={{ fontSize: '20px' }}>{value.quantidade.toLocaleString('pt-br', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      })}</IonLabel>
                      <IonIcon size='large' color='success' icon={addCircle} onClick={() => updateQuantity(index, 1)}></IonIcon>
                    </IonChip>
                  </IonLabel>
                </IonCol>
                <IonCol style={{ display: "flex", justifyContent: "flex-end" }} sizeSm='6'>
                  <IonButtons>
                    <IonButton disabled={false}
                      onClick={() => {
                        mostrarAlerta({
                          backdropDismiss: false,
                          header: 'Remover item',
                          message: 'Deseja <strong>remover</strong>?',
                          buttons: [
                            {
                              text: 'Cancelar',
                              role: 'cancel',
                            },
                            {
                              text: 'Confirmar',
                              cssClass: 'primary',
                              handler: () => {
                                deletarItemProdutos(index);
                              }
                            }
                          ],
                          onDidDismiss: (e) => console.log('did dismiss'),
                        });
                      }}
                    >
                      <IonIcon color="primary" icon={trash} />
                    </IonButton>
                  </IonButtons>
                </IonCol>

              </IonRow>
            </>
          ))}
        </IonGrid>
      </>
    );
  }

  function carregarSomasItemProdutos() {

    // Calcula a nova soma dos valores após a remoção
    const totalValor = listaItemProdutos.reduce((total: any, item: any) => {
      const itemValorNumerico = parseFloat(
        item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
      );
      return total + itemValorNumerico;
    }, 0);

    // Exemplo: você pode armazenar a nova soma em outro estado ou usar conforme necessário
    console.log("Nova soma dos valores:", totalValor);

    setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }));

  }

  function deletarItemProdutos(index: number) {
    // Filtra a lista de produtos, removendo o item com o índice fornecido
    const itemRemovido = listaItemProdutos[index];
    const updatedList = listaItemProdutos.filter((_: any, i: any) => i !== index);

    // Atualiza a lista de produtos com o item removido
    setListaItemProdutos(updatedList);

    // Analytics: RemoveFromCart
    try { if (itemRemovido) analytics.trackRemoveFromCart(itemRemovido); } catch (e) { /* noop */ }

    // Calcula a nova soma dos valores após a remoção
    const totalValor = updatedList.reduce((total: any, item: any) => {
      const itemValorNumerico = parseFloat(
        item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
      );
      return total + itemValorNumerico;
    }, 0);

    // Exemplo: você pode armazenar a nova soma em outro estado ou usar conforme necessário
    console.log("Nova soma dos valores:", totalValor);

    setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }));

  }

  const truncarTexto = (texto: string, limite: number) => {
    return texto.length > limite ? texto.substring(0, limite) + "..." : texto;
  };


  async function closeModalEndereco(enderecoSelecionado: any, latitudeSelecionado: any, enderecoLngSelecionado: any, taxaEntregaSelecionado: any, tempoEntregaSelecionado: any, complementoSelecionado: any, bairroSelecionado?: string) {
    console.log("enderecoSelecionado", enderecoSelecionado);
    console.log("latitudeSelecionado", latitudeSelecionado);
    console.log("enderecoLngSelecionado", enderecoLngSelecionado);
    console.log("taxaEntregaSelecionado", taxaEntregaSelecionado);
    console.log("tempoEntregaSelecionado", tempoEntregaSelecionado);
    console.log("complementoSelecionado", complementoSelecionado);

    setEndereco(enderecoSelecionado);
    setEnderecoLat(latitudeSelecionado);
    setEnderecoLng(enderecoLngSelecionado);

    setTaxaEntrega(taxaEntregaSelecionado);
    setTempoEntrega(tempoEntregaSelecionado);
    setComplemento(complementoSelecionado || "");
    setBairro(bairroSelecionado || '');
    saveDeliveryAddress({
      endereco: enderecoSelecionado,
      latitude: latitudeSelecionado,
      longitude: enderecoLngSelecionado,
      complemento: complementoSelecionado || "", bairro: bairroSelecionado
    });
    saveDeliveryTerms(taxaEntregaSelecionado, tempoEntregaSelecionado);

    if (Array.isArray(dadosEmpresa.configuracoesEntrega) && dadosEmpresa.configuracoesEntrega.length > 0 && enderecoSelecionado === "RETIRADA") {
      const tempos = dadosEmpresa.configuracoesEntrega?.map((c: any) => parseInt(c.tempo));
      const tempoMinimo = Math.min(...tempos);

      setTempoEntrega(tempoMinimo);
      localStorage.setItem("tempoEntrega", tempoMinimo?.toString());

    }

    setShowDetalhesEndereco(false);
  }

  async function closeModalSimpleEndereco() {
    setShowDetalhesEndereco(false);
  }

  async function closeModalAgendamentoSimple() {
    setShowModalAgendamento(false);
  }

  async function closeModalAgendamento(dataAgendamento: any, horaAgendamento: any, tipoAgendamento: any) {
    setShowModalAgendamento(false);
    setTipoAgendamento(tipoAgendamento);
    setDataAgendamento(dataAgendamento);
    setHoraAgendamento(horaAgendamento);
    localStorage.setItem("tipoAgendamento", tipoAgendamento);
    localStorage.setItem("dataAgendamento", dataAgendamento);
    localStorage.setItem("horaAgendamento", horaAgendamento);

    if (!endereco) {
      setShowDetalhesEndereco(true);
    }
  }

  async function closeModalPedidoFechar() {
    setShowPedidoFechar(false);
  }

  async function closeModalPedidoFecharSucess(pedidoId?: string) {
    await props.closeAction(pedidoId);
    setShowPedidoFechar(false);
  }

  async function closeModalDesconto() {
    setShowModalDesconto(false);
  }

  async function closeModalDescontoSucess(desconto: any, cupom: any) {

    if (desconto && cupom) {
      setDesconto(desconto);
      setCupom(cupom);
    }
    else {
      setDesconto("");
      setCupom("");
    }

    setShowModalDesconto(false);
  }

  useEffect(() => {
    setResgateCashBack(current => appliedCashback(current, valorTotalProdutos, taxaEntrega, desconto));
  }, [valorTotalProdutos, taxaEntrega, desconto]);

  async function closeModalCashBack() {
    setShowModalCashBack(false);
  }

  async function closeModalCashBackSucess(valorResgate: number) {
    await confirmarUsoCashback(valorResgate);
  }

  async function closeModalEntrarSimple() {
    if (!cashbackActionInFlight.current) setShowModalEntrar(false);
  }

  async function closeModalEntrar(nome?: string, telefone?: string) {
    await fazerLoginAutomatico(nome, telefone);
  }

  async function fazerLoginAutomatico(nome: string = "", telefone: string = "") {
    if (cashbackActionInFlight.current || recoverBeforeChangingCashback()) return;
    const nomeFinal = (nome || localStorage.getItem("nome") || "").trim();
    const telefoneFinal = (telefone || localStorage.getItem("telefone") || "").trim();

    if (!nomeFinal || !telefoneFinal) {
      setTextToast("Erro ao fazer login. Dados incompletos.");
      setShowToast(true);
      return;
    }

    const company = cashbackCompany.current;
    if (!company) { reportCashbackError('Reabra o carrinho para identificar a loja.'); return; }
    cashbackActionInFlight.current = true; setShowLoading(true);
    const session = cashbackSession();

    try {
      const body = {
        nome: nomeFinal,
        telefone: telefoneFinal,
      };

      const response = await fetch(cadastrarELogarDireto.url, {
        method: cadastrarELogarDireto.method,
        headers: {
          'Content-Type': 'application/json',
          perfil: localStorage.getItem('perfil') || 'cliente',
          marca: localStorage.getItem('marca') || ''
        } as HeadersInit,
        credentials: 'include',
        body: JSON.stringify(body)
      });

      const retorno = await response.json();

      if (![200, 201].includes(response.status)) throw new Error(retorno.message || 'Não foi possível entrar. Tente novamente.');
      const token = typeof retorno.token === 'string' ? retorno.token.trim() : '';
      if (!token || /\s/.test(token)) throw new Error('Não foi possível confirmar seu acesso. Tente novamente.');
      if (company !== cashbackCompany.current || session !== cashbackSession())
        throw new Error('Seus dados mudaram. Tente acessar o cashback novamente.');
      if (recoverBeforeChangingCashback()) return;
      localStorage.setItem('token', `token=${token}`);
      localStorage.setItem('nome', nomeFinal); localStorage.setItem('telefone', telefoneFinal);
      const result = await carregarCashback(company);
      if (result.status === 'ready') {
        setShowModalEntrar(false); setShowModalCashBack(true);
      } else if (result.status !== 'stale') {
        reportCashbackError('Não foi possível consultar seu cashback após entrar. Tente novamente. Seu carrinho foi mantido.');
      }
    } catch (error) {
      reportCashbackError(error instanceof Error ? error.message : 'Não foi possível entrar. Seu carrinho foi mantido.');
    } finally {
      cashbackActionInFlight.current = false; setShowLoading(false);
    }
  }

  // Função para formatar a data no padrão brasileiro
  const formatarData = formatCalendarDate;

  // Função para formatar a hora
  function formatarHora(isoTime: string): string {
    if (!isoTime) return "";
    // Extrair a parte da hora do formato ISO (2025-12-01T18:10)
    const timePart = isoTime.includes('T') ? isoTime.split('T')[1] : isoTime;
    const [hora, minuto] = timePart.split(':');
    return `${hora}:${minuto}`;
  }

  return (
    <>

      <IonHeader className="ion-no-border">
        <IonToolbar className="pedido-fluxo-modal-toolbar">
          <IonButtons slot="start" className="pedido-fluxo-back-buttons">
            <IonButton aria-label="Voltar" className="pedido-fluxo-back-button" fill="clear" onClick={() => props.closeActionVoltar()}>
              <IonIcon icon={arrowBackOutline} />
            </IonButton>
          </IonButtons>
          <IonTitle className="ion-text-wrap"><span className="modal-title-text">Carrinho</span></IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>

        <div style={{ padding: '0px', color: "var(--ion-color-medium)" }}>



          <IonItem
            lines="none"
            button
            detail={true}
            hidden={!dadosEmpresa.agendamento && tipoAgendamento !== 'AGENDADO'}
            onClick={() => setShowModalAgendamento(true)}
          >



            {!tipoAgendamento ? (
              <>
                <IonIcon
                  icon={calendarOutline}
                  slot="start"
                  color="danger"
                />
                <IonLabel color="danger">Data do Pedido</IonLabel>
              </>
            ) : tipoAgendamento === "AGORA" ? (
              <>
                <IonIcon
                  icon={calendarOutline}
                  slot="start"
                  color="success"
                />
                <div style={{ fontSize: '12px' }}>
                  <IonLabel class="ion-text-wrap" color="success">
                    <b style={{ color: "var(--ion-color-success)" }}>
                      AGORA
                    </b>
                  </IonLabel>
                </div>
              </>
            ) : (
              <>
                <IonIcon
                  icon={calendarOutline}
                  slot="start"
                  color="success"
                />
                <div style={{ fontSize: '12px' }}>
                  <IonLabel class="ion-text-wrap" color="success">
                    <b style={{ color: "var(--ion-color-success)" }}>
                      {truncarTexto(`${formatarData(dataAgendamento)} às ${formatarHora(horaAgendamento)}`, 80)}
                    </b>
                  </IonLabel>
                </div>
              </>
            )}
          </IonItem>

          <IonItem

            lines="none"
            button
            detail={true}

            onClick={() => setShowDetalhesEndereco(true)}
          // style={{
          //   borderColor: '#dddddd', borderWidth: '1px', borderStyle: 'solid'
          // }}
          >

            {!endereco ? (
              <>

                <IonIcon
                  icon={locationOutline}
                  slot="start"
                  color="danger"
                />
                <IonLabel color="danger">Calcular taxa de entrega</IonLabel>
              </>
            ) : (
              <>
                <IonIcon
                  icon={locationOutline}
                  slot="start"
                  color="success"
                />

                <div style={{ fontSize: '12px' }}>
                  <IonLabel class="ion-text-wrap" color="success">
                    <b style={{ color: "var(--ion-color-success)" }}>
                      {truncarTexto(`${endereco}${complemento ? " / " + complemento : ""}`, 80)}
                    </b>
                  </IonLabel>
                  <IonLabel color="success" hidden={dadosEmpresa.agendamento && (tipoAgendamento == "" || tipoAgendamento == "AGENDADO")}>
                    {endereco === "RETIRADA"
                      ? tempoEntrega ? `Retirada em ${tempoEntrega} minutos` : ""
                      : `Entrega em ${tempoEntrega} minutos / R$ ${taxaEntrega}`}
                  </IonLabel>

                </div>

              </>
            )}

          </IonItem>



          <IonGrid>


            <IonRow style={{ borderColor: 'grey', fontSize: '25px', borderWidth: '1px', borderBottomStyle: 'solid' }}>
              <IonCol size="12"><IonLabel><b>Itens adicionados</b></IonLabel></IonCol>
            </IonRow>

          </IonGrid>

          <div>
            <div>
              {loadItemProdutos()}
              <CartSuggestions empresa={dadosEmpresa} produtos={listaItemProdutos}
                agendamento={tipoAgendamento === 'AGENDADO' ? { data: dataAgendamento, hora: horaAgendamento } : undefined}
                adicionarItem={props.adicionarItem} onChooseProduct={props.onChooseProduct} />
            </div>
          </div>

        </div>



        <IonModal className="fullscreen-modal"
          onDidPresent={() => {
            if (inputRefEndereco.current) {
              inputRefEndereco.current.setFocus();
            }
          }} isOpen={showDetalhesEndereco} onDidDismiss={() => { setShowDetalhesEndereco(false); }}>
          <Endereco endereco={endereco} inputRef={inputRefEndereco} closeAction={closeModalEndereco} closeActionSimple={closeModalSimpleEndereco}></Endereco>
        </IonModal>

        <IonModal
          className="medium-modal"
          isOpen={showModalAgendamento}
          onDidDismiss={() => { setShowModalAgendamento(false); }}
          style={{
            '--backdrop-opacity': '0.4',              // opacidade do cinza
            '--backdrop-background': 'rgba(0,0,0,0.4)' // cor exata do overlay
          }}
        >
          <Agendamento closeActionSimple={closeModalAgendamentoSimple} closeAction={closeModalAgendamento}></Agendamento>
        </IonModal>


        <IonModal className="fullscreen-modal" isOpen={showPedidoFechar} onDidDismiss={() => { setShowPedidoFechar(false); }}>
          <PedidoFechar produtos={listaItemProdutos} logado={props.logado || cashbackAuthenticated} desconto={desconto} cupom={cupom} resgateCashBack={resgateCashBack} closeAction={closeModalPedidoFecharSucess} closeActionSimple={closeModalPedidoFechar}
            onCashbackChange={setResgateCashBack}
            onDeliveryChange={(taxa, tempo) => { setTaxaEntrega(taxa); setTempoEntrega(tempo); }} />
        </IonModal>

        <IonModal className="fullscreen-modal" isOpen={showModalCashBack} onDidDismiss={() => { closeModalCashBack(); }}>
          <Cashback totalCashBack={totalCashBack} resgateCashBack={resgateCashBack} items={listCashBack} closeAction={closeModalCashBackSucess} closeActionSimple={closeModalCashBack}></Cashback>
        </IonModal>

        <IonModal
          className="mini-modal"
          isOpen={showModalEntrar}
          // Ionic checks dismissal before updating the next prop. Keep app-controlled
          // closure available; back/backdrop/gestures remain blocked during login.
          canDismiss={async (_data, role) => role === undefined || !cashbackActionInFlight.current}
          onDidDismiss={() => { setShowModalEntrar(false); }}
          style={{
            '--backdrop-opacity': '0.4',
            '--backdrop-background': 'rgba(0,0,0,0.4)'
          }}
        >
          <Entrar nome={localStorage.getItem("nome") || ""} celular={localStorage.getItem("telefone") || ""} logado={false}
            mensagem="Entre para usar seu cashback. Seu carrinho será mantido."
            closeActionSimple={closeModalEntrarSimple} closeAction={closeModalEntrar}></Entrar>
        </IonModal>

        <IonModal className="fullscreen-modal" isOpen={showModalDesconto} onDidDismiss={() => { closeModalDesconto(); }}>
          <Cupom configuracoesCupom={dadosEmpresa.configuracoesCupom} cupom={cupom} valorProdutos={parseFloat(String(valorTotalProdutos || '0').replace(/\./g, '').replace(/\,/g, '.')) || 0} valorTaxaEntrega={parseFloat(String(taxaEntrega || '0').replace(/\./g, '').replace(/\,/g, '.')) || 0} closeAction={closeModalDescontoSucess} closeActionSimple={closeModalDesconto}></Cupom>
        </IonModal>

      </IonContent>

      <IonFooter>

        <IonToolbar style={{ padding: '10px' }}>

          <div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

              {/* Resumo subtotal, desconto, taxa de serviço, total geral */}
              <IonGrid style={{ padding: "0px", margin: "0px" }}>

                <IonRow style={{ fontSize: '16px' }}>
                  <IonCol style={{}} size="5"><IonLabel><b>Subtotal</b></IonLabel></IonCol>
                  <IonCol style={{}} size="7"><IonLabel style={{ display: 'block', textAlign: "right" }}><b>{valorTotalProdutos ? "R$ " + valorTotalProdutos : "R$ 0,00"}</b></IonLabel></IonCol>

                </IonRow>

                {dadosEmpresa?.configuracoesCupom && dadosEmpresa.configuracoesCupom.length > 0 && (
                  <IonRow style={{ fontSize: '16px' }}>
                    <IonCol size="7">
                      <IonLabel>
                        <IonIcon size='small' icon={ticketOutline}></IonIcon> Cupom
                      </IonLabel>
                    </IonCol>
                    <IonCol size="5" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                      {!desconto ? (
                        <IonLabel
                          color="success"
                          style={{
                            fontWeight: 'bold',
                            cursor: 'pointer',
                          }}
                          onClick={() => setShowModalDesconto(true)}
                        >
                          Adicionar
                        </IonLabel>
                      ) : (
                        <IonLabel
                          color="primary"
                          style={{
                            fontWeight: 'bold',
                            cursor: 'pointer',
                          }}
                          onClick={() => setShowModalDesconto(true)}
                        >
                          {cupom}
                        </IonLabel>
                      )}
                    </IonCol>
                  </IonRow>
                )}

                {dadosEmpresa?.cashbackAtivado && (
                  <IonRow style={{ fontSize: '16px' }}>
                    <IonCol size="7">
                      <IonLabel>
                        <IonIcon size='small' icon={syncOutline}></IonIcon> Cashback
                      </IonLabel>
                    </IonCol>
                    <IonCol size="5" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                      <IonButton fill="clear" size="small" aria-label="Usar cashback" disabled={showLoading}
                        style={{ fontWeight: 'bold', textTransform: 'none', margin: 0 }}
                        color={!cashbackAuthenticated ? 'danger' : resgateCashBack > 0 ? 'primary' : 'success'}
                        onClick={() => { void confirmarUsoCashback(); }}>
                        {!cashbackAuthenticated ? 'Entrar' : resgateCashBack > 0
                          ? `- R$ ${resgateCashBack.toLocaleString('pt-br', { minimumFractionDigits: 2 })}` : 'Adicionar'}
                      </IonButton>
                    </IonCol>
                  </IonRow>
                )}



                <IonRow style={{ fontSize: '16px' }}>
                  <IonCol style={{}} size="7"><IonLabel>Taxa de entrega</IonLabel></IonCol>
                  <IonCol style={{}} size="5"><IonLabel style={{ display: 'block', textAlign: "right" }}>{taxaEntrega ? "R$ " + taxaEntrega : "R$ 0,00"}</IonLabel></IonCol>

                </IonRow>

                <IonRow style={{ fontSize: '20px' }}>
                  <IonCol style={{}} size="5"><IonLabel><b>Total</b></IonLabel></IonCol>
                  <IonCol style={{}} size="7"><IonLabel style={{ display: 'block', textAlign: "right" }}><b>{valorTotal ? "R$ " + valorTotal : "R$ 0,00"}</b></IonLabel></IonCol>

                </IonRow>

              </IonGrid>


            </div>
          </div>

          {deliveryQuote.loading && <p role="status">Atualizando frete e prazo...</p>}
          {deliveryQuote.error && <div role="alert"><p>{deliveryQuote.error}</p>
            <IonButton onClick={() => deliveryQuote.refresh()}>Tentar novamente</IonButton></div>}
          <IonButton
            disabled={deliveryQuote.loading}
            // color="success"
            style={{ height: "46px", fontSize: "18px" }}
            onClick={async () => {

              console.log("listaItemProdutos", listaItemProdutos);

              // Bloqueio quando a loja está temporariamente fechada para novos pedidos.
              if (dadosEmpresa?.deliveryFechado === true) {
                const motivo = getDeliveryClosedReason(dadosEmpresa);
                setTextToast(`Loja temporariamente fechada para novos pedidos.${motivo ? ` Motivo: ${motivo}` : ''}`);
                setShowToast(true);
                return;
              }
              console.log("endereco", endereco);
              if (!endereco) { setShowDetalhesEndereco(true); return; }
              if (dadosEmpresa.agendamento && !tipoAgendamento) { setShowModalAgendamento(true); return; }
              const currentQuote = await deliveryQuote.refresh(true);
              if (!currentQuote) {
                setTextToast('Não foi possível confirmar a entrega. Revise o endereço e o agendamento ou tente novamente.');
                setShowToast(true); return;
              }
              if (cartNumber(currentQuote.taxa) !== cartNumber(taxaEntrega) || currentQuote.tempo !== String(tempoEntrega || '')) {
                setTextToast('O frete ou prazo foi atualizado. Revise a entrega e toque em Continuar novamente.');
                setShowToast(true); return;
              }

              // Horário e agendamento já foram validados com as condições atuais.
              const valorTotalProdutosNumerico = cartNumber(valorTotalProdutos);
              if (listaItemProdutos?.length === 0) {
                setTextToast("Selecione pelo menos um produto.");
                setShowToast(true); return;
              }
              if (valorTotalProdutosNumerico < cartNumber(dadosEmpresa.pedidoMinimo)) {
                setTextToast("Pedido mínimo de R$ " + (dadosEmpresa.pedidoMinimo || "0,00") + " em produtos.");
                setShowToast(true); return;
              }
              console.log("listaItemProdutos", listaItemProdutos);
              console.log("props.logado", props.logado);

              if (
                desconto &&
                Array.isArray(dadosEmpresa.configuracoesCupom)

              ) {

                const cupomSelecionado = dadosEmpresa.configuracoesCupom.find((configCupom: any) => configCupom.nome === cupom);

                console.log("valorTotalProdutosNumerico", valorTotalProdutosNumerico);
                console.log("cupomSelecionado", cupomSelecionado);

                if (cupomSelecionado && cupomSelecionado.valorMinimo) {

                  let cupomSelecionadoFloat = parseFloat(cupomSelecionado.valorMinimo?.replace(/\./g, '').replace(/\,/g, '.'));

                  if (valorTotalProdutosNumerico < cupomSelecionadoFloat) {

                    setTextToast("Não é possível realizar o pedido com esse cupom devido o valor mínimo de R$ " + cupomSelecionado.valorMinimo + " em produtos.");
                    setShowToast(true);
                    return;
                  }
                }

              }

              // Validação de estoque antes de avançar para o checkout
              // Usa catalogoProdutos como fonte autoritativa (mesmo que o back),
              // pois complementos no carrinho podem não carregar controlarEstoque.
              const catalogoProdutosContinuar: any[] = dadosEmpresa?.catalogoProdutos || [];

              const demandaTotalPorId: Record<string, number> = {};
              (listaItemProdutos || []).forEach((cartItem: any) => {
                const cartQtd = parseFloat(
                  (cartItem.quantidade || '0').toString().replace(/\./g, '').replace(/,/g, '.')
                ) || 0;
                if (Array.isArray(cartItem.descricao)) {
                  cartItem.descricao.forEach((sub: any) => {
                    if (!sub.id) return;
                    const catalogItem = catalogoProdutosContinuar.find((c: any) => c.id === sub.id);
                    if (catalogItem && catalogItem.controlarEstoque) {
                      const m = String(sub.descricao || '').match(/^(\d+)x\s/);
                      const sq = m ? parseInt(m[1], 10) : 1;
                      demandaTotalPorId[sub.id] = (demandaTotalPorId[sub.id] || 0) + sq * cartQtd;
                    }
                  });
                } else if (cartItem.id) {
                  const catalogItem = catalogoProdutosContinuar.find((c: any) => c.id === cartItem.id);
                  if (catalogItem && catalogItem.controlarEstoque) {
                    demandaTotalPorId[cartItem.id] = (demandaTotalPorId[cartItem.id] || 0) + cartQtd;
                  }
                }
              });

              let estoqueExcedidoContinuar = false;
              let msgEstoqueContinuar = '';
              for (const [itemId, totalDemandado] of Object.entries(demandaTotalPorId)) {
                const catalogItem = catalogoProdutosContinuar.find((c: any) => c.id === itemId);
                if (catalogItem && catalogItem.controlarEstoque) {
                  const estoqueAtual = Number(catalogItem.quantidadeEstoque) || 0;
                  if (totalDemandado > estoqueAtual) {
                    estoqueExcedidoContinuar = true;
                    const nome = catalogItem.nome || catalogItem.descricao || itemId;
                    msgEstoqueContinuar = `O item "${nome}" possui apenas ${estoqueAtual} unidade(s) disponível(eis) e o pedido solicita ${totalDemandado}.`;
                    break;
                  }
                }
              }

              if (estoqueExcedidoContinuar) {
                setTextToast(msgEstoqueContinuar);
                setShowToast(true);
                return;
              }

              setDesconto(desconto);
              // Analytics: InitiateCheckout
              try {
                const totalNum = parseFloat(String(valorTotalProdutos || 0).replace(/\./g, '').replace(/\,/g, '.')) || 0;
                analytics.trackInitiateCheckout(listaItemProdutos, totalNum);
              } catch (e) { /* noop */ }
              setShowPedidoFechar(true);

            }}
            expand="block"
            type="submit"
          >
            Continuar
          </IonButton>



        </IonToolbar>
      </IonFooter >

      <IonToast
        isOpen={showToast}
        position="middle" //top, bottom, middle
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={3000}
      />


      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoading}
        onDidDismiss={() => { setShowLoading(false); }}
        spinner='circles'
      />

    </>
  );
};

export default Carrinho;
